// Value of `action_category` on the row Science adds to
// action_plan_outcome_category_kits for the retest step. Its number and title
// are Science's too, and its outcome is a placeholder with no recommendation.
export const RETEST_ACTION_CATEGORY = 'Retest';

export const isRetestRow = (row: { action_category?: string | null }) =>
  row.action_category === RETEST_ACTION_CATEGORY;
